import React from 'react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { Card1, Card2 } from 'components/Card';
import { useDevice } from 'components/DeviceContext.js';

const ObtencaoDeRecursos = () => {
    const { isMobile } = useDevice();
    return (
        <Grid container style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: isMobile ? 'column' : '',
            maxHeight: isMobile ? '100%' : '100%',
            fontFamily: 'Open sans',
            padding: isMobile ? '1em' : ' 2em 0 5em'
        }}>

            <Grid item xs={12} md={4} lg={5} style={{}}>
                <p style={{ color: 'var(--azul-vivido)', fontWeight: 400, fontSize: '2.5rem' }}>
                    Obtenção de recursos para o FIA Municipal</p>

                <TableContainer component={Paper}>
                    <Table aria-label="fontes-de-receita">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{
                                    backgroundColor: 'var(--azul)',
                                    color: 'var(--branco)',
                                    textAlign: 'center',
                                    fontSize: '20px'
                                }}>As fontes de receita do FIA Municipal</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ backgroundColor: 'var(--branco-fumaca)' }}>• Doações de pessoas físicas ou jurídicas, dedutíveis do Imposto de Renda, nos termos da Lei 8.069/1990 - ECA;</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: 'var(--laranja-claro)' }}>• Multas aplicadas nos termos previstos da Lei 8.069/1990 – ECA;</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: 'var(--laranja-claro)' }}>• Recursos advindos da dotação orçamentária do governo;</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: 'var(--laranja-claro)' }}>• Contribuições de governos e organismos internacionais; e</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ backgroundColor: 'var(--laranja-claro)' }}>• Recursos oriundos da aplicação dos recursos no mercado financeiro.</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
                <p
                    style={{
                        backgroundColor: 'var(--azul-pastel)',
                        color: 'var(--azul-petroleo)',
                        borderRadius: '0.4em',
                        padding: '1em'
                    }}><span
                        style={{
                            fontWeight: 700
                        }}>IMPORTANTE!</span><br />O Conselho/fundo deve informar anualmente a Receita Federal sobre as doações recebidas mês a mês, com a identificação dos doadores (nome, CPF ou CNPJ).</p>

            </Grid>
            <Grid item xs={12} md={6} lg={4} style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Card1 />
                <Card2 />

            </Grid>
        </Grid>
    );
}

export default ObtencaoDeRecursos;
